import { useCaseLandingView } from "src/pages/case-landing/case-landing-view-model";
import { QuestionsAboutScheme } from "src/components/questions-about-scheme/questions-about-scheme";
import { OptOut } from "src/components/opt-out/opt-out";

export type OptStatus = "opt-in" | "opt-out";

const CaseLandingPage = () => {
  const { view, showOptInOut, standardFaq } = useCaseLandingView();
  if (showOptInOut === undefined) {
    return view;
  }

  return (
    <div className="flex flex-col items-start gap-10">
      {view}

      <QuestionsAboutScheme standardInfo={standardFaq} />
      {showOptInOut && <OptOut />}
    </div>
  );
};

export default CaseLandingPage;
